module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v2_common/check2-6a16f8826499f616b6de870a1a68f6a6.svg";